import { ExternalHyperlink, ImageRun, Paragraph, Tab, TabStopPosition, TabStopType, TextRun } from "docx";
export function createTabbedImages(images, executionDate) {
    var size = 3;
    var batches = [];
    for (var i = 0; i < images.length; i += size) {
        batches.push(images.slice(i, i + size));
    }
    ;
    var tabs = [
        {
            type: TabStopType.CENTER,
            position: Math.floor(TabStopPosition.MAX * 1 / 6)
        },
        {
            type: TabStopType.CENTER,
            position: Math.floor(TabStopPosition.MAX * 3 / 6)
        },
        {
            type: TabStopType.CENTER,
            position: Math.floor(TabStopPosition.MAX * 5 / 6)
        }
    ];
    return batches.flatMap(function (batch) {
        return [
            new Paragraph({ text: "", keepNext: true }),
            new Paragraph({
                children: batch.flatMap(function (image, index) {
                    var height = image.height / (image.width / 180);
                    return [
                        new TextRun({
                            children: [
                                new Tab()
                            ]
                        }),
                        new ExternalHyperlink({
                            children: [
                                new ImageRun({ data: image.data, transformation: { width: 180, height: height } })
                            ],
                            link: image.link
                        })
                    ];
                }),
                tabStops: tabs,
                keepNext: true
            }),
            new Paragraph({
                children: batch.flatMap(function (image, index) {
                    return [
                        new TextRun({
                            children: [
                                new Tab(),
                                image.description
                            ]
                        }),
                    ];
                }),
                tabStops: tabs,
                keepNext: true
            }),
            new Paragraph({
                children: batch.flatMap(function (image, index) {
                    return [
                        new TextRun({
                            children: [
                                new Tab(),
                                executionDate
                            ]
                        }),
                    ];
                }),
                tabStops: tabs,
                keepNext: true
            }),
            new Paragraph("")
        ];
    });
}
